import React from "react";
import NavListSingleElement from "components/HOCs/MenuNav/Nav/NavListSingleElement/NavListSingleElement";
import "./Nav.scss";

const listMenuItems = [
	{
		navigateTo: "/",
		svgIconName: "inicio",
		spanContent: "Inicio",
		iconClassName: "fontIcon--home",
	},
	{
		navigateTo: "/catalogo",
		svgIconName: "catalogo",
		spanContent: "Catálogo de flexores",
		iconClassName: "fontIcon--catalogue",
	},
	{
		navigateTo: "/sucursales",
		svgIconName: "sucursales",
		spanContent: "Sucursales",
		iconClassName: "fontIcon--branchOffices",
	},
	{
		navigateTo: "/sobre-nosotros",
		svgIconName: "nosotros",
		spanContent: "Sobre nosotros",
		iconClassName: "fontIcon--about",
	},
];

const listMenuItemsAdmin = [
	{
		navigateTo: "/panel-control",
		svgIconName: "sucursales",
		spanContent: "Panel de control",
		iconClassName: "fontIcon--controlPanel",
	},
	{
		navigateTo: "/panel-control-catalogo",
		svgIconName: "catalogo",
		spanContent: "Editar catálogo",
		iconClassName: "fontIcon--catalogueEdit",
	},
	{
		navigateTo: "/panel-control-sucursales",
		svgIconName: "sucursales",
		spanContent: "Editar sucursales",
		iconClassName: "fontIcon--branchOfficesEdit",
	},
	{
		navigateTo: "/",
		spanContent: "Cerrar sesión",
		iconClassName: "fontIcon--logout",
		action: "close",
	},
];

const Nav = ({ setMenuStatus, colorIcons, menuMobile, onAuth, setAuth }) => {
	return (
		<ul className="sidebarMenu__ul">
			{!onAuth
				? listMenuItems.map((i, index) => {
					const key = index + 1
					return (
						<NavListSingleElement
							navigateTo={i.navigateTo}
							svgIconName={i.svgIconName}
							spanContent={i.spanContent}
							setMenuStatus={menuMobile ? setMenuStatus : false}
							colorIcons={colorIcons}
							iconClassName={i.iconClassName}
							action={i.action}
							index={key}
						/>
					);
				})
				: listMenuItemsAdmin.map((i, index) => {
					const key = index + 1
					return (
						<NavListSingleElement
							navigateTo={i.navigateTo}
							svgIconName={i.svgIconName}
							spanContent={i.spanContent}
							setMenuStatus={menuMobile ? setMenuStatus : false}
							colorIcons={colorIcons}
							iconClassName={i.iconClassName}
							setAuth={setAuth}
							action={i.action}
							index={key}
						/>
					);
				})}
		</ul>
	);
};

export default Nav;
